import { render, staticRenderFns } from "./TheBaseLayout.vue?vue&type=template&id=1195439c&scoped=true&"
import script from "./TheBaseLayout.vue?vue&type=script&lang=js&"
export * from "./TheBaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheBaseLayout.vue?vue&type=style&index=0&id=1195439c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1195439c",
  null
  
)

export default component.exports